import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";

import completionStatic from "../../../assets/completion-static.png";
import { USER_TYPE } from "../../../constants/common";
import { useNavigateWithLang } from "../../../utils/navigation";
import CustomModal from "../../CustomModal";

const SuccessPublishPlaygroundModal = forwardRef(({}, ref) => {
  const { t } = useTranslation();
  const navigate = useNavigateWithLang();

  const [isOpen, setIsOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    openModal() {
      setIsOpen(true);
    },
    closeModal() {
      setIsOpen(false);
    },
  }));

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  return (
    <CustomModal
      isOpen={isOpen}
      withCloseButton={false}
      onClose={handleCloseModal}
      className="max-w-[40rem] rounded-3xl border-8 border-blue-500 bg-[#F1F1F1] shadow-xl"
      contentClassname="p-6 bg-[#F1F1F1] px-0"
    >
      <div className="flex flex-col items-center p-6 text-center">
        <img src={completionStatic} className="w-72" alt="" />
        <button
          onClick={handleCloseModal}
          className="wavy-btn relative mt-8 w-2/6 rounded-3xl border-4 border-[#96B8F3] bg-blue-500 p-4 text-lg font-semibold text-white transition duration-200 hover:bg-blue-600"
        >
          {t("continue")}
        </button>
      </div>
    </CustomModal>
  );
});

export default SuccessPublishPlaygroundModal;
